import type {SourceChunkLayout} from '@github-ui/taillights-worker/source-chunks'

export const windowedSourceChunkLines = 30
const guardLines = 8

export interface SourceWindow {
  first: number
  last: number
  viewportHeight: number
}

export function sourceBlockAt(blocks: readonly SourceChunkLayout[], displayLine: number) {
  let low = 0
  let high = blocks.length
  while (low < high) {
    const middle = (low + high) >>> 1
    const block = blocks[middle]
    if (!block) throw new RangeError('Invalid source block index')
    if (block.displayStart + Math.max(1, block.lineNumbers.length) <= displayLine) low = middle + 1
    else high = middle
  }
  return Math.max(0, Math.min(blocks.length - 1, low))
}

export function sourceWindowForViewport(
  blocks: readonly SourceChunkLayout[],
  lineHeight: number,
  scrollTop: number,
  viewportHeight: number,
): SourceWindow {
  const firstLine = Math.max(0, Math.floor(scrollTop / lineHeight) - guardLines)
  const lastLine = Math.max(0, Math.ceil((scrollTop + viewportHeight) / lineHeight) + guardLines - 1)
  return {
    first: sourceBlockAt(blocks, firstLine),
    last: sourceBlockAt(blocks, lastLine),
    viewportHeight,
  }
}

export function sameSourceWindow(a: SourceWindow, b: SourceWindow) {
  return a.first === b.first && a.last === b.last && a.viewportHeight === b.viewportHeight
}
